import { useIsMobile } from '@autone/utils';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@radix-ui/react-collapsible';

import {
  SidebarMenuArrow,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
} from '../components/SidebarMenu';
import { useSidebarContext } from '../context/SidebarContext';
import {
  type SidebarNavigationItemProps,
  type SidebarSubNavigationItemProps,
} from '../types/Sidebar.types';

import { SidebarCollapsedSubMenu } from './SidebarCollapsedSubMenu';
import { SidebarSubItem } from './SidebarSubItem';

interface SidebarCollapsibleItemProps {
  item: SidebarNavigationItemProps & {
    subItems: SidebarSubNavigationItemProps[];
  };
}

export const SidebarCollapsibleItem = ({
  item,
}: SidebarCollapsibleItemProps) => {
  const { state } = useSidebarContext();
  const isMobile = useIsMobile();

  // When collapsed, show submenu in popover on hover
  if (state === 'collapsed' && !isMobile) {
    return <SidebarCollapsedSubMenu subItem={item} />;
  }
  // When expanded, show normal collapsible submenu
  return (
    <Collapsible className="group/collapsible">
      <CollapsibleTrigger className="w-full" disabled={item.isDisabled}>
        <SidebarMenuItem>
          <SidebarMenuButton
            tooltip={item.title}
            isActive={item.isActive}
            isDisabled={item.isDisabled}
          >
            {item.icon && <item.icon />}
            <span>{item.title}</span>
            <SidebarMenuArrow />
          </SidebarMenuButton>
        </SidebarMenuItem>
      </CollapsibleTrigger>
      <CollapsibleContent className="pb-2">
        <SidebarMenuSub>
          {item.subItems.map((subItem) => (
            <SidebarSubItem
              subItem={subItem}
              key={subItem.title}
              className="text-sidebar-foreground hover:text-foreground"
            />
          ))}
        </SidebarMenuSub>
      </CollapsibleContent>
    </Collapsible>
  );
};
